export default "__VITE_ASSET__CJg9JqLs__"